// Dependencies
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'our-artists',
  components: { Carousel, Slide }
}



// WEBPACK FOOTER //
// ./src/components/our-artists/script.js